import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
export function Countdown() {
  const [timeLeft, setTimeLeft] = useState(15 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className="inline-flex items-center gap-2 bg-hyrox-dark/50 border border-hyrox-orange/30 text-hyrox-orange px-4 py-2 rounded-full font-mono font-bold text-sm sm:text-base shadow-[0_0_15px_rgba(255,107,26,0.15)]" aria-live="polite" data-id="element-57">
      <ClockIcon className="w-4 h-4 sm:w-5 sm:h-5 animate-pulse" data-id="element-58" />
      <span data-id="element-59">PRECIO DE LANZAMIENTO EXPIRA EN:</span>
      <span data-id="element-60">
        {minutes.toString().padStart(2, '0')}:
        {seconds.toString().padStart(2, '0')}
      </span>
    </div>;
}